import React, { memo } from 'react';

export interface SelectableItemProps {
  id: string;
  title: string;
  subtitle?: string;
  iconPath?: string;
  isSelected: boolean;
  badgeText?: string;
  themeColor: string;
  onClick: (id: string) => void;
  className?: string;
}

export const SelectableItem: React.FC<SelectableItemProps> = memo(({
  id,
  title,
  subtitle,
  iconPath,
  isSelected,
  badgeText,
  themeColor,
  onClick,
  className = "morgana-list-item" // Default to existing class for now to maintain style
}) => {
  
  return (
    <div
      className={`${className} ${isSelected ? 'selected' : ''}`}
      onClick={() => onClick(id)}
      style={{
        borderColor: isSelected ? themeColor : 'rgba(255, 255, 255, 0.1)'
      }}
      role="button"
      aria-label={`${title}${isSelected ? ' selected' : ''}`}
    >
      <div className="flex gap-3 items-start">
        {iconPath && (
          <img
            src={iconPath}
            alt={title}
            className="w-12 h-12 object-contain rounded border border-white/20"
          />
        )}
        <div style={{ flex: 1 }}>
          <div className="morgana-item-header">
            <div style={{ fontWeight: 700, color: themeColor }}>
              {title}
            </div>
            {isSelected && badgeText && (
              <div 
                className="morgana-selection-badge" 
                style={{ backgroundColor: themeColor, color: 'black' }}
              >
                {badgeText}
              </div>
            )}
          </div>
          {subtitle && (
            <div className="text-white text-xs">
              {subtitle}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
